import React, { useEffect, useState } from "react";
import Button from "../../../components/common/button";
import { useLocation, useNavigate } from "react-router-dom";
import { fetchBankLeadData, updateFirestoreDoc } from "../../../api";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../../../config/firebaseConfig";
import { toast } from "react-hot-toast";
import Modal from "../../../components/common/modal";
import { useAuthData } from "../../../context/AuthContext";

export const Oppsummering: React.FC<{
  setActiveTab: any;
}> = ({ setActiveTab }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const pathSegments = location.pathname.split("/");
  const id = pathSegments.length > 2 ? pathSegments[2] : null;
  const [bankData, setBankData] = useState<any>();
  const { adminData } = useAuthData();

  useEffect(() => {
    if (!id) {
      return;
    }

    const getData = async () => {
      const data = await fetchBankLeadData(id);
      setBankData(data);
    };

    getData();
  }, [id]);
  const [finalData, setFinalData] = useState<any>(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const husmodellDocRef = doc(
          db,
          "house_model",
          String(bankData?.plotHusmodell?.house?.housemodell)
        );
        const husmodellDocSnap = await getDoc(husmodellDocRef);

        if (husmodellDocSnap.exists()) {
          setFinalData(husmodellDocSnap.data());
        } else {
          console.error("No document found for husmodell ID.");
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    if (bankData?.plotHusmodell?.house?.housemodell) {
      fetchData();
    }
  }, [bankData]);
  const plotData = bankData?.plotHusmodell?.plot;
  const houseData = bankData?.plotHusmodell?.house;

  function norwegianToNumber(str: any) {
    if (typeof str !== "string") return 0;
    return Number(str.replace(/\s/g, ""));
  }

  const sum =
    norwegianToNumber(plotData?.tomtekostnader) +
    norwegianToNumber(houseData?.byggekostnader);

  function numberToNorwegian(num: any) {
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
  }

  const [Role, setRole] = useState<any>(null);

  useEffect(() => {
    const getData = async () => {
      if (adminData) {
        if (adminData?.role) {
          setRole(adminData?.role);
        }
      }
    };

    getData();
  }, [adminData]);

  const sendWelcomeEmail = async () => {
    try {
      const officeId = bankData?.Kunden?.Kundeinformasjon[0]?.office;

      let officeName = "";
      if (officeId) {
        const officeRef = doc(db, "office", officeId);
        const officeSnap = await getDoc(officeRef);
        if (officeSnap.exists()) {
          officeName = officeSnap.data()?.data?.name || officeName;
        }
      }
      const currentOrigin =
        typeof window !== "undefined" ? window.location.origin : "";
      if (currentOrigin === "https://admin.mintomt.no") {
        const response = await fetch(
          "https://nh989m12uk.execute-api.eu-north-1.amazonaws.com/prod/banklead",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              action: "send-welcome",
              email: "rudraksh.shukla98@gmail.com",
              fields: {
                FNAME: bankData?.Kunden?.Kundeinformasjon[0]?.f_name,
                LNAME: bankData?.Kunden?.Kundeinformasjon[0]?.l_name,
                phone: bankData?.Kunden?.Kundeinformasjon[0]?.mobileNummer,
                email: bankData?.Kunden?.Kundeinformasjon[0]?.EPost,
                dealer: "BoligPartner",
                office: officeName,
                projectAddress: bankData?.plotHusmodell?.plot?.address,
                landCost: `kr ${plotData?.tomtekostnader}`,
                buildingCost: `kr ${houseData?.byggekostnader}`,
                totalCost: `kr ${numberToNorwegian(sum)}`,
                link: `${process.env.REACT_APP_REDIRECT_URL_ADMIN}/bank-leads-detail/${id}`,
              },
            }),
          }
        );
        const formatDate = (date: Date) => {
          return date
            .toLocaleString("sv-SE", { timeZone: "UTC" })
            .replace(",", "");
        };

        const docRef = doc(db, "bank_leads", String(id));

        if (id) {
          const snap = await getDoc(docRef);

          if (snap.exists()) {
            const data = snap.data();

            if (data.status === "Ikke sendt") {
              await updateFirestoreDoc(db, "bank_leads", String(id), {
                status: "Sendt",
                updatedAt: formatDate(new Date()),
              });
            }
          }
        }

        const result = await response.json();
        toast.success(result.message, {
          position: "top-right",
        });
      }
      navigate("/bank-leads");
    } catch (error) {
      console.error("Error:", error);
    }
  };

  // const sendWelcomeEmail = async () => {
  //   try {
  //     const officeId = bankData?.Kunden?.Kundeinformasjon[0]?.office;

  //     let officeName = "";
  //     if (officeId) {
  //       const officeRef = doc(db, "office", officeId);
  //       const officeSnap = await getDoc(officeRef);
  //       if (officeSnap.exists()) {
  //         officeName = officeSnap.data()?.data?.name || officeName;
  //       }
  //     }
  //     const fields = {
  //       FNAME: bankData?.Kunden?.Kundeinformasjon[0]?.f_name,
  //       LNAME: bankData?.Kunden?.Kundeinformasjon[0]?.l_name,
  //       phone: bankData?.Kunden?.Kundeinformasjon[0]?.mobileNummer,
  //       email: bankData?.Kunden?.Kundeinformasjon[0]?.EPost,
  //       dealer: "BoligPartner",
  //       office: officeName,
  //       projectAddress: bankData?.plotHusmodell?.plot?.address,
  //       landCost: `kr ${plotData?.tomtekostnader}`,
  //       buildingCost: `kr ${houseData?.byggekostnader}`,
  //       totalCost: `kr ${numberToNorwegian(sum)}`,
  //       link: `${process.env.REACT_APP_REDIRECT_URL_ADMIN}/bank-leads-detail/${id}`,
  //     };

  //   } catch (error) {
  //     console.error("Error:", error);
  //   }
  // };

  const [isPopup, setIsPopup] = useState(false);
  const handleConfirmPopup = () => {
    if (isPopup) {
      setIsPopup(false);
    } else {
      setIsPopup(true);
    }
  };

  return (
    <>
      <div className="rounded-lg bg-lightGreen mb-20 w-full">
        <div className="p-3 md:p-4">
          <h3 className="text-base lg:text-lg font-semibold text-black3 mb-2">
            Oppsummering
          </h3>
          <p className="text-sm text-gray4">
            Her fyller du inn informasjon om prosjektet.
          </p>
        </div>
        <div className="p-1 pt-0">
          <div className="bg-white p-4 rounded-lg border border-gray3 shadow-shadow4">
            <div className="text-sm lg:text-base text-black3 font-medium">
              Informasjon om kunden
            </div>
            <div className="py-3 md:py-5 grid grid-cols-1 desktop:grid-cols-2 gap-4 md:gap-6">
              {bankData &&
                bankData?.Kunden?.Kundeinformasjon.length &&
                bankData?.Kunden?.Kundeinformasjon.map(
                  (item: any, index: number) => {
                    return (
                      <div className="flex flex-col gap-2" key={index}>
                        <div className="flex gap-2 md:gap-3 items-center">
                          <div className="w-[130px] sm:w-[200px] md:w-[300px] text-gray4 text-xs md:text-sm">
                            Type
                          </div>
                          <div className="w-[calc(100%-130px)] sm:w-[calc(100%-200px)] md:w-[calc(100%-300px)] break-all text-darkBlack text-xs md:text-sm">
                            {item?.Kundetype}
                          </div>
                        </div>
                        <div className="flex gap-3 items-center">
                          <div className="w-[130px] sm:w-[200px] md:w-[300px] text-gray4 text-xs md:text-sm">
                            Navn:
                          </div>
                          <div className="w-[calc(100%-130px)] sm:w-[calc(100%-200px)] md:w-[calc(100%-300px)] break-all  text-darkBlack text-xs md:text-sm">
                            {item?.f_name} {item?.l_name}
                          </div>
                        </div>
                        <div className="flex gap-3 items-center">
                          <div className="w-[130px] sm:w-[200px] md:w-[300px] text-gray4 text-xs md:text-sm">
                            Adresse:
                          </div>
                          <div className="w-[calc(100%-130px)] sm:w-[calc(100%-200px)] md:w-[calc(100%-300px)] break-all  text-darkBlack text-xs md:text-sm">
                            {item?.Adresse}
                          </div>
                        </div>
                        <div className="flex gap-3 items-center">
                          <div className="w-[130px] sm:w-[200px] md:w-[300px] text-gray4 text-xs md:text-sm">
                            Mobil:
                          </div>
                          <div className="w-[calc(100%-130px)] sm:w-[calc(100%-200px)] md:w-[calc(100%-300px)] break-all  text-darkBlack text-xs md:text-sm">
                            {item?.mobileNummer}
                          </div>
                        </div>
                        <div className="flex gap-3 items-center">
                          <div className="w-[130px] sm:w-[200px] md:w-[300px] text-gray4 text-xs md:text-sm">
                            E-post:
                          </div>
                          <div className="w-[calc(100%-130px)] sm:w-[calc(100%-200px)] md:w-[calc(100%-300px)] break-all  text-darkBlack text-xs md:text-sm">
                            {item?.EPost}
                          </div>
                        </div>
                        <div className="flex gap-3 items-center">
                          <div className="w-[130px] sm:w-[200px] md:w-[300px] text-gray4 text-xs md:text-sm">
                            Fødselsdato:
                          </div>
                          <div className="w-[calc(100%-130px)] sm:w-[calc(100%-200px)] md:w-[calc(100%-300px)] break-all  text-darkBlack text-xs md:text-sm">
                            {item?.dato}
                          </div>
                        </div>
                      </div>
                    );
                  }
                )}
            </div>
            <div className="border-t border-gray4 mb-5"></div>
            <div className="text-sm lg:text-base text-black3 font-medium">
              Informasjon om tomten
            </div>
            <div className="py-3 md:py-5">
              <div className="flex flex-col gap-2">
                <div className="flex gap-3 items-center">
                  <div className="w-[130px] sm:w-[200px] md:w-[300px] text-gray4 text-xs md:text-sm">
                    Adresse:
                  </div>
                  <div className="w-[calc(100%-130px)] sm:w-[calc(100%-200px)] md:w-[calc(100%-300px)] break-all text-darkBlack text-xs md:text-sm">
                    {plotData?.address}
                  </div>
                </div>
                <div className="flex gap-3 items-center">
                  <div className="w-[130px] sm:w-[200px] md:w-[300px] text-gray4 text-xs md:text-sm">
                    Kunden eier tomten allerede:
                  </div>
                  <div className="w-[calc(100%-130px)] sm:w-[calc(100%-200px)] md:w-[calc(100%-300px)] break-all text-darkBlack text-xs md:text-sm">
                    {plotData?.alreadyHavePlot
                      ? plotData?.alreadyHavePlot
                      : "Nei"}
                  </div>
                </div>
                <div className="flex gap-3 items-center">
                  <div className="w-[130px] sm:w-[200px] md:w-[300px] text-gray4 text-xs md:text-sm">
                    Totale tomtekostnader:
                  </div>
                  <div className="w-[calc(100%-130px)] sm:w-[calc(100%-200px)] md:w-[calc(100%-300px)] break-all text-darkBlack text-xs md:text-sm">
                    kr {plotData?.tomtekostnader}
                  </div>
                </div>
                <div className="flex gap-3 items-center">
                  <div className="w-[130px] sm:w-[200px] md:w-[300px] text-gray4 text-xs md:text-sm">
                    Kommentar:
                  </div>
                  <div className="w-[calc(100%-130px)] sm:w-[calc(100%-200px)] md:w-[calc(100%-300px)] break-all text-darkBlack text-xs md:text-sm">
                    {plotData?.Kommentar}
                  </div>
                </div>
              </div>
            </div>
            <div className="border-t border-gray4 mb-3 md:mb-5"></div>
            <div className="text-sm lg:text-base text-black3 font-medium">
              Informasjon om husmodellen
            </div>
            <div className="py-3 md:py-5">
              <div className="flex flex-col gap-2">
                <div className="flex gap-3 items-center">
                  <div className="w-[130px] sm:w-[200px] md:w-[300px] text-gray4 text-xs md:text-sm">
                    Husmodell
                  </div>
                  <div className="w-[calc(100%-130px)] sm:w-[calc(100%-200px)] md:w-[calc(100%-300px)] break-all text-darkBlack text-xs md:text-sm">
                    {finalData?.Husdetaljer?.husmodell_name}
                  </div>
                </div>
                <div className="flex gap-3 items-center">
                  <div className="w-[130px] sm:w-[200px] md:w-[300px] text-gray4 text-xs md:text-sm">
                    Totale byggekostnader:
                  </div>
                  <div className="w-[calc(100%-130px)] sm:w-[calc(100%-200px)] md:w-[calc(100%-300px)] break-all text-darkBlack text-xs md:text-sm">
                    kr {houseData?.byggekostnader}
                  </div>
                </div>
                <div className="flex gap-3 items-center mb-3">
                  <div className="w-[130px] sm:w-[200px] md:w-[300px] text-gray4 text-xs md:text-sm">
                    Kommentar:
                  </div>
                  <div className="w-[calc(100%-130px)] sm:w-[calc(100%-200px)] md:w-[calc(100%-300px)] break-all text-darkBlack text-xs md:text-sm">
                    {houseData?.Kommentar}
                  </div>
                </div>
              </div>
            </div>
            <div className="border-t border-gray4 mb-3 md:mb-5"></div>
            <div className="text-sm lg:text-base text-black3 font-medium">
              Informasjon om økonomisk plan
            </div>
            <div className="py-3 md:py-5">
              <div className="flex flex-col gap-2">
                <div className="flex gap-3 items-center">
                  <div className="w-[130px] sm:w-[200px] md:w-[300px] text-gray4 text-xs md:text-sm">
                    Lastet opp
                  </div>
                  <div className="w-[calc(100%-130px)] sm:w-[calc(100%-200px)] md:w-[calc(100%-300px)] break-all text-darkBlack text-xs md:text-sm">
                    {bankData?.ProjectAccount?.Økonomisk ===
                    "Last opp en økonomisk plan"
                      ? "Ja"
                      : "Nei"}
                  </div>
                </div>
                <div className="flex gap-3 items-center">
                  <div className="w-[130px] sm:w-[200px] md:w-[300px] text-gray4 text-xs md:text-sm">
                    Operettet
                  </div>
                  <div className="w-[calc(100%-130px)] sm:w-[calc(100%-200px)] md:w-[calc(100%-300px)] break-all text-darkBlack text-xs md:text-sm">
                    {bankData?.ProjectAccount?.Økonomisk ===
                    "Opprett en økonomisk plan"
                      ? "Ja"
                      : "Nei"}
                  </div>
                </div>
                <div className="flex gap-3 items-center mb-3">
                  <div className="w-[130px] sm:w-[200px] md:w-[300px] text-gray4 text-xs md:text-sm">
                    Ettersendes
                  </div>
                  <div className="w-[calc(100%-130px)] sm:w-[calc(100%-200px)] md:w-[calc(100%-300px)] break-all text-darkBlack text-xs md:text-sm">
                    {bankData?.ProjectAccount?.Økonomisk ===
                    "Ettersend en økonomisk plan"
                      ? "Ja"
                      : "Nei"}
                  </div>
                </div>
              </div>
            </div>
            <div className="bg-skyBlue rounded-lg py-3 px-3 md:px-4 flex flex-col gap-2 sm:gap-3">
              <div className="flex gap-2 sm:gap-3 items-center">
                <div className="w-[130px] sm:w-[200px] md:w-[300px] text-gray4 text-xs md:text-sm">
                  Sum tomtekostnader
                </div>
                <div className="w-[calc(100%-130px)] sm:w-[calc(100%-200px)] md:w-[calc(100%-300px)] break-all text-darkBlack text-xs md:text-sm font-medium">
                  kr {plotData?.tomtekostnader}
                </div>
              </div>
              <div className="flex gap-2 sm:gap-3 items-center">
                <div className="w-[130px] sm:w-[200px] md:w-[300px] text-gray4 text-xs md:text-sm">
                  Sum byggekostnader
                </div>
                <div className="w-[calc(100%-130px)] sm:w-[calc(100%-200px)] md:w-[calc(100%-300px)] break-all text-darkBlack text-xs md:text-sm font-medium">
                  kr {houseData?.byggekostnader}{" "}
                  <span className="text-gray4 text-xs md:text-sm font-normal">
                    (prosjektregnskapet oversendes banken)
                  </span>
                </div>
              </div>
              <div className="border-t border-grey2 w-full"></div>
              <div className="flex gap-2 sm:gap-3 items-center">
                <div className="w-[130px] sm:w-[200px] md:w-[300px] font-medium text-darkBlack text-xs md:text-sm">
                  Totale kostnader
                </div>
                <div className="w-[calc(100%-130px)] sm:w-[calc(100%-200px)] md:w-[calc(100%-300px)] break-all text-darkBlack text-xs md:text-sm font-medium">
                  kr {numberToNorwegian(sum)}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="bg-white pb-2 bottom-0 fixed w-[calc(100%-16px)] left-2">
        <div className="flex justify-end w-full gap-4 items-center  bg-white z-50 border border-gray3 p-3 md:p-4">
          <div onClick={() => setActiveTab(2)}>
            <Button
              text="Tilbake"
              className="border-2 border-primary text-primary text-base rounded-[34px] h-10 md:h-12 font-semibold relative px-6 md:px-8 py-[10px] flex items-center gap-2"
            />
          </div>
          <Button
            text="Send til bank"
            className="border border-primary bg-primary text-white text-base rounded-[34px] h-10 md:h-12 font-semibold relative px-6 md:px-8 py-[10px] flex items-center gap-2"
            onClick={() => {
              if (Role === "Admin" || Role === "super-admin") {
                handleConfirmPopup();
              } else {
                sendWelcomeEmail();
              }
            }}
          />
        </div>
      </div>

      {isPopup && (
        <Modal onClose={handleConfirmPopup} isOpen={true}>
          <div className="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-50">
            <div className="bg-white p-6 rounded-lg shadow-lg">
              <p className="text-lg font-semibold mb-4">
                Er du sikker på at du vil sende denne e-posten til banken?
              </p>

              <div className="flex justify-center mt-5 w-full gap-5 items-center">
                <div
                  onClick={() => {
                    setIsPopup(false);
                    navigate("/bank-leads");
                  }}
                >
                  <Button
                    text="Avbryt"
                    className="border border-gray2 text-black text-sm rounded-[8px] h-[40px] font-medium relative px-4 py-[10px] flex items-center gap-2"
                  />
                </div>
                <div
                  onClick={() => {
                    sendWelcomeEmail();
                    setIsPopup(false);
                  }}
                >
                  <Button
                    text="Bekrefte"
                    className="border border-primary bg-primary text-white text-sm rounded-[8px] h-[40px] font-medium relative px-4 py-[10px] flex items-center gap-2"
                  />
                </div>
              </div>
            </div>
          </div>
        </Modal>
      )}
    </>
  );
};
